export const mlayout = [
  {
    name: 'UIFrameEntity',
    objects: [
      {
        name: 'frame',
        type: 'NineSlicePlane',
        width: 5,
        height: 50,
        from: 'atlases/footer.png',
        orientation: {
          land: {
            x: -750,
            y: 457,
            v: 1,
          },
        },
      },
      {
        name: 'frameP',
        type: 'NineSlicePlane',
        width: 5,
        height: 200,
        from: 'atlases/footer.png',
        orientation: {
          port: {
            x: -500,
            y: 850,
            v: 1,
          },
        },
      },
      {
        name: 'net',
        type: 'NineSlicePlane',
        width: 5,
        height: 50,
        from: 'atlases/net-land.png',
        orientation: {
          land: {
            x: -750,
            y: 500,
            v: 1,
          },
        },
      },
      {
        name: 'netFrameP',
        type: 'NineSlicePlane',
        width: 5,
        height: 96.97,
        from: 'atlases/net-port.png',
        orientation: {
          port: {
            x: -499.47,
            y: 937.5,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'ReelsEntity',
    objects: [
      {
        name: 'reel-0',
        type: 'Reel',
        x: 0,
        y: 0,
        width: 105.5,
        height: 399,
      },
      {
        name: 'reel-1',
        type: 'Reel',
        x: 105.5,
        y: 0,
        width: 105.5,
        height: 399,
      },
      {
        name: 'reel-2',
        type: 'Reel',
        x: 211,
        y: 0,
        width: 105.5,
        height: 399,
      },
      {
        name: 'reel-3',
        type: 'Reel',
        x: 316.5,
        y: 0,
        width: 105.5,
        height: 399,
      },
      {
        name: 'reel-4',
        type: 'Reel',
        x: 422,
        y: 0,
        width: 105.5,
        height: 399,
      },
      {
        name: 'mask',
        type: 'Mask',
        x: 0,
        y: 0,
        width: 527.5,
        height: 394,
      },
      {
        name: 'swipe',
        type: 'SpinSwipeButton',
        x: 0,
        y: 0,
        width: 527.5,
        height: 399,
        alpha: '0',
        runtime: { platform: 'mobile,tablet' },
      },
    ],
    properties: {
      include: true,
      scale: '1.92',
      x: '-510',
      y: '-415',
    },
    orientation: {
      land: {
        x: 200,
        y: 100,
        scale: 1,
      },
      port: {
        x: 16.62,
        y: 216.47,
        scale: 1,
      },
    },
  },
  {
    name: 'SymbolValueEntity',
    objects: [
      {
        name: 'symbol-value',
        type: 'SymbolValuePopup',
        x: -230,
        y: -91,
        width: '211',
        height: '266',
        color: '#8dbf6e',
        customStyle: 'symbolText',
        texture: 'SymbolValueBack',
      },
    ],
    properties: {
      include: true,
      scale: '1.92',
      x: '-510',
      y: '-420',
    },
    orientation: {
      land: {
        x: 230,
        y: 91,
        scale: 1,
      },
      port: {
        x: 16.62,
        y: 216.47,
        scale: 1,
      },
    },
  },
  {
    name: 'OverReelEntity',
    objects: [
      {
        name: '0',
        type: 'OverReelAnimation',
        x: 0,
        y: 0,
        width: 105.5,
        height: 399,
      },
      {
        name: '1',
        type: 'OverReelAnimation',
        x: 105.5,
        y: 0,
        width: 105.5,
        height: 399,
      },
      {
        name: '2',
        type: 'OverReelAnimation',
        x: 213.5,
        y: 0,
        width: 105.5,
        height: 399,
      },
      {
        name: '3',
        type: 'OverReelAnimation',
        x: 316.5,
        y: 0,
        width: 105.5,
        height: 399,
      },
      {
        name: '4',
        type: 'OverReelAnimation',
        x: 419.5,
        y: 0,
        width: 105.5,
        height: 399,
      },
    ],
    properties: {
      include: true,
      scale: '2',
      x: '-540',
      y: '-435',
    },
    orientation: {
      land: {
        x: 200,
        y: 100,
        scale: 1,
      },
      port: {
        x: 16.62,
        y: 216.47,
        scale: 1,
      },
    },
  },
  {
    name: 'LinesEntity',
    objects: [
      {
        name: 'container',
        type: 'LinesContainer',
        x: 0,
        y: 0,
        width: 527.5,
        height: 399,
      },
    ],
    properties: {
      include: true,
      scale: '2',
      x: '-540',
      y: '-430',
    },
    orientation: {
      land: {
        x: 200,
        y: 100,
        scale: 1,
      },
      port: {
        x: 16.62,
        y: 216.47,
        scale: 1,
      },
    },
  },
  {
    name: 'TextLineEntity',
    objects: [
      {
        name: 'line-win-text',
        type: 'LineWinText',
        width: 699.915,
        height: 108.115,
        fontBitmap: 'bitmap',
        letterSpacing: 10,
        text: '$10.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 75,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 699.915,
        },
        orientation: {
          land: {
            x: 90,
            y: 215.385,
          },
          port: {
            x: 90,
            y: 215,
          },
        },
      },
    ],
    properties: {
      include: true,
      scale: '2.2',
      x: '-960',
      y: '-650',
    },
  },
  {
    name: 'Base',
    objects: [
      {
        name: 'freeSpinEndCounter',
        type: 'FreespinsTotalWinPopupText',
        width: 617.835,
        height: 617.835,
        fontBitmap: 'bitmap',
        includeObj: true,
        letterSpacing: 10,
        text: '50.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 750,
          align: 'left',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 617.835,
        },
        orientation: {
          land: {
            x: 0,
            y: 0,
          },
          port: {
            x: 0,
            y: 0,
          },
        },
      },
      {
        name: 'mainSpine',
        type: 'TriggerSpine',
        width: 0,
        height: 0,
        animation: '0',
        buttonSignal: 'BUTTON:endFreespin,BUTTON:startFreespin',
        buttons: 'button_continue,button_start',
        include: 'bg_bg,frame_base,fs_bg,fs_tube_1,fs_tube_2,intermediate_bg,reel_fs,ReelsEntity,OverReelEntity,SymbolValueEntity,LinesEntity,TextLineEntity,freeSpinEndCounter',
        includeSlot: 'bg_bg,frame_base,fs_bg,fs_tube_1,fs_tube_2,intermediate_bg,reel_fs,reel,reel,reel,reel,reel,1000',
        includeType: 'sprite,sprite,sprite,sprite,sprite,sprite,sprite,entity,entity,entity,entity,entity,obj',
        oriented: false,
        spine: 'animations/spine/background/skeleton.json',
        orientation: {
          land: {
            x: 480,
            y: 270,
            scale: 0.5,
          },
          port: {
            x: 270,
            y: 470,
            scale: 0.5,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'HeaderBaseEntity',
    objects: [
      {
        name: 'logo-main',
        type: 'AnimationSpine',
        width: 0,
        height: 0,
        animation: 'land',
        direction: true,
        oriented: false,
        spine: 'animations/spine/main-logo/skeleton.json',
        orientation: {
          land: {
            x: 125,
            y: 120,
            scale: 0.5,
          },
        },
      },
      {
        name: 'logo-main-p',
        type: 'AnimationSpine',
        width: 0,
        height: 0,
        animation: 'port',
        oriented: false,
        spine: 'animations/spine/main-logo/skeleton.json',
        orientation: {
          port: {
            x: 265,
            y: -60,
            scale: 0.5,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreespinHeaderEntity',
    objects: [
      {
        name: 'logo-fs',
        type: 'AnimationSpine',
        width: 0,
        height: 0,
        animation: 'land',
        direction: true,
        oriented: false,
        spine: 'animations/spine/fs-logo/skeleton.json',
        orientation: {
          land: {
            x: 481.25,
            y: 30,
            scale: 0.5,
          },
        },
      },
      {
        name: 'logo-fs-p',
        type: 'AnimationSpine',
        width: 0,
        height: 0,
        animation: 'port',
        oriented: false,
        spine: 'animations/spine/fs-logo/skeleton.json',
        orientation: {
          port: {
            x: 265,
            y: 225,
            scale: 0.5,
          },
        },
      },
      {
        name: 'logo-main',
        type: 'AnimationSpine',
        width: 0,
        height: 0,
        animation: 'land',
        direction: true,
        oriented: false,
        spine: 'animations/spine/main-logo/skeleton.json',
        orientation: {
          land: {
            x: 125,
            y: 120,
            scale: 0.5,
          },
        },
      },
      {
        name: 'logo-main-p-fs',
        type: 'AnimationSpine',
        width: 0,
        height: 0,
        animation: 'port-fs',
        oriented: false,
        spine: 'animations/spine/main-logo/skeleton.json',
        orientation: {
          port: {
            x: 265,
            y: -65,
            scale: 0.5,
          },
        },
      },
      {
        name: 'x3',
        type: 'AnimationSpine',
        width: 0,
        height: 0,
        animation: 'land',
        direction: false,
        oriented: false,
        spine: 'animations/spine/3x/skeleton.json',
        orientation: {
          land: {
            x: 590,
            y: 30,
            scale: 0.5,
          },
        },
      },
      {
        name: 'x3-p',
        type: 'AnimationSpine',
        width: 0,
        height: 0,
        animation: 'land',
        direction: false,
        oriented: false,
        spine: 'animations/spine/3x/skeleton.json',
        orientation: {
          port: {
            x: 415,
            y: 220,
            scale: 0.5,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'WinAnimationEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 0,
        height: 0,
        orientation: {
          land: {
            x: -318,
            y: -24,
          },
          port: {
            x: -293,
            y: -178,
          },
        },
      },
      {
        name: 'customstretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'bigwins',
        type: 'BigWinTitle',
        width: 0,
        height: 0,
        scale: 0.27,
        orientation: {
          land: {
            x: 485,
            y: 270,
          },
          port: {
            x: 280,
            y: 455,
          },
        },
      },
      {
        name: 'you-win-big',
        type: 'BigWinCounter',
        width: 955.805,
        height: 63.5,
        fontBitmap: 'bitmap',
        letterSpacing: 10,
        text: '$10.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 65,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 955.805,
        },
        orientation: {
          land: {
            x: 4.3,
            y: 390,
          },
          port: {
            x: -200,
            y: 660,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'MenuBackEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'AutoMenuEntity',
    objects: [
      {
        name: 'loss-0',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 230,
            y: 295,
          },
          port: {
            x: 143.17,
            y: 389,
          },
        },
      },
      {
        name: 'autoselected',
        type: 'Image',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: ['images/icons/button-0.png'],
        orientation: {
          port: {
            x: 213.25,
            y: 201.67,
          },
          land: {
            x: 424.29,
            y: 118.83,
          },
        },
      },
      {
        name: 'loss-1',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 359.5,
            y: 295,
          },
          port: {
            x: 275.17,
            y: 388.5,
          },
        },
      },
      {
        name: 'prevauto',
        type: 'DecreaseAutoButton',
        width: 21,
        height: 30,
        hitzone: 8,
        scale: 0.8786764705882353,
        images: [
          'images/icons/bet-left-0.png',
          'images/icons/bet-left-1.png',
        ],
        orientation: {
          port: {
            x: 56.75,
            y: 215,
          },
          land: {
            x: 266.96,
            y: 128.5,
          },
        },
      },
      {
        name: 'loss-2',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 487.5,
            y: 295,
          },
          port: {
            x: 144.84,
            y: 456.5,
          },
        },
      },
      {
        name: 'nextauto',
        type: 'IncreaseAutoButton',
        width: 20,
        height: 30,
        hitzone: 8,
        scale: 0.857843137254902,
        images: [
          'images/icons/bet-right-0.png',
          'images/icons/bet-right-1.png',
        ],
        orientation: {
          port: {
            x: 468.25,
            y: 216.25,
          },
          land: {
            x: 673.38,
            y: 128.5,
          },
        },
      },
      {
        name: 'loss-3',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 617,
            y: 295,
          },
          port: {
            x: 276.17,
            y: 454.5,
          },
        },
      },
      {
        name: 'win-0',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 230,
            y: 410,
          },
          port: {
            x: 151.34,
            y: 582.5,
          },
        },
      },
      {
        name: 'win-1',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 359,
            y: 410,
          },
          port: {
            x: 280.5,
            y: 581.5,
          },
        },
      },
      {
        name: 'win-2',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 488,
            y: 410,
          },
          port: {
            x: 148.84,
            y: 649.67,
          },
        },
      },
      {
        name: 'win-3',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 617,
            y: 410,
          },
          port: {
            x: 278.5,
            y: 649.67,
          },
        },
      },
      {
        name: 'win',
        type: 'AutoLimitSelectedText',
        width: 495.705,
        height: 35,
        text: 'winlimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 495.705,
        },
        orientation: {
          land: {
            x: 233.125,
            y: 362.165,
          },
          port: {
            x: 20.07,
            y: 532.835,
          },
        },
      },
      {
        name: 'loss',
        type: 'AutoLimitSelectedText',
        width: 480.47,
        height: 35,
        text: 'losslimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 480.47,
        },
        orientation: {
          port: {
            x: 31.865,
            y: 341.5,
          },
          land: {
            x: 235.08,
            y: 239.665,
          },
        },
      },
      {
        name: 'loss-0',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 230,
            y: 295,
          },
          port: {
            x: 142.665,
            y: 389.835,
          },
        },
      },
      {
        name: 'loss-1',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 359.5,
            y: 295,
          },
          port: {
            x: 276.335,
            y: 390.165,
          },
        },
      },
      {
        name: 'loss-2',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 487.5,
            y: 295,
          },
          port: {
            x: 144.335,
            y: 457.165,
          },
        },
      },
      {
        name: 'loss-3',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'noLimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 617,
            y: 295,
          },
          port: {
            x: 276.665,
            y: 455.5,
          },
        },
      },
      {
        name: 'win-0',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 230,
            y: 410,
          },
          port: {
            x: 149,
            y: 583,
          },
        },
      },
      {
        name: 'win-1',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 359,
            y: 410,
          },
          port: {
            x: 278,
            y: 583,
          },
        },
      },
      {
        name: 'win-2',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 488,
            y: 410,
          },
          port: {
            x: 149,
            y: 650,
          },
        },
      },
      {
        name: 'win-3',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'noLimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 617.5,
            y: 410,
          },
          port: {
            x: 278.335,
            y: 650.665,
          },
        },
      },
      {
        name: 'autoplay',
        type: 'Text',
        width: 426,
        height: 28,
        text: 'autoHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 426,
        },
        orientation: {
          land: {
            x: 263,
            y: 29,
          },
          port: {
            x: 56,
            y: 93,
          },
        },
      },
      {
        name: 'number',
        type: 'Text',
        width: 433,
        height: 35,
        text: 'numberSpins',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 433,
        },
        orientation: {
          land: {
            x: 263,
            y: 69,
          },
          port: {
            x: 56,
            y: 154,
          },
        },
      },
      {
        name: 'settings',
        type: 'Text',
        width: 429,
        height: 34.5,
        text: 'extendedSettings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 429,
        },
        orientation: {
          land: {
            x: 267,
            y: 191.5,
          },
          port: {
            x: 56,
            y: 280,
          },
        },
      },
      {
        name: 'auto-carousel',
        type: 'AutoCarousel',
        width: 113,
        height: 47.5,
        text: '2',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 424.285,
            y: 118.835,
          },
          port: {
            x: 213.75,
            y: 204.5,
          },
        },
      },
      {
        name: 'ui-automenu',
        type: 'RadioButton',
        width: 55,
        height: 55,
        deselect: true,
        direction: true,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 658,
            y: 34,
          },
          port: {
            x: 451.84,
            y: 98.5,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'PaytableEntity',
    objects: [
      {
        name: 'PaytableEntity-header-text',
        type: 'Text',
        x: 0.01,
        y: 21.5,
        width: 960,
        height: 50,
        text: 'paytableHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 36,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'PrevAutoPage',
        type: 'DecreasePageButton',
        x: 271.51,
        y: 465,
        width: 12,
        height: 17,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/main/paytable/bet-left-0.png',
          'images/main/paytable/bet-left-1.png',
        ],
      },
      {
        name: 'NextAutoPage',
        type: 'IncreasePageButton',
        x: 680.01,
        y: 465,
        width: 12,
        height: 17,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/main/paytable/bet-right-0.png',
          'images/main/paytable/bet-right-1.png',
        ],
      },
      {
        name: 'AutoCaruselPage',
        type: 'PageCarousel',
        x: 468.51,
        y: 465,
        width: 15,
        height: 15,
        scale: 0.5,
        images: [
          'images/main/paytable/dot-0.png',
          'images/main/paytable/dot-1.png',
        ],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: -0.005,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 268,
        y: 66,
        width: 426,
        height: 394,
        alpha: 0.01,
      },
      {
        name: 'hot-features',
        type: 'Text',
        x: 0,
        y: 75,
        width: 960,
        height: 50,
        text: 'hotHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 24,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'PaytableEntity-freespins-describe-text',
        type: 'Text',
        x: 283.63,
        y: 284.94,
        width: 396.705,
        height: 65,
        text: 'freespinsPayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 396.705,
        },
      },
      {
        name: 'freespins-pt',
        type: 'Image',
        x: 299.67,
        y: 142.75,
        width: 359,
        height: 118.9,
        scale: 0.7670953956437827,
        images: ['images/main/paytable/15_fs.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 268,
        y: 66,
        width: 426,
        height: 394,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-scatter-describe-text',
        type: 'Text',
        x: 251.4,
        y: 293,
        width: 458.485,
        height: 134.46,
        text: 'scatterPayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 458.485,
        },
      },
      {
        name: 'hot-features',
        type: 'Text',
        x: 0,
        y: 75,
        width: 960,
        height: 50,
        text: 'hotHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 24,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'scatter-img',
        type: 'Image',
        x: 374.59,
        y: 43.92,
        width: 212.915,
        height: 268.415,
        scale: 1.0090773883761537,
        images: ['images/main/items/static/1.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 268,
        y: 66,
        width: 426,
        height: 394,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-wild-describe-text',
        type: 'Text',
        x: 243.84,
        y: 297.81,
        width: 470.21,
        height: 132.1,
        text: 'wildPayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 470.21,
        },
      },
      {
        name: 'hot-features',
        type: 'Text',
        x: 0,
        y: 64,
        width: 960,
        height: 50,
        text: 'hotHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 24,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'wild-img',
        type: 'Image',
        x: 378.75,
        y: 64.17,
        width: 202.86,
        height: 255.74,
        scale: 0.9614251861882194,
        images: ['images/main/items/static/2.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 268,
        y: 66,
        width: 426,
        height: 394,
        alpha: 0.01,
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 222.5,
        width: 28,
        height: 21.5,
        text: '2',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 200,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 177.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 155,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 155,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 177.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 200,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 222.5,
        width: 28,
        height: 21.5,
        text: '2',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 382.5,
        width: 28,
        height: 21.5,
        text: '2',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 360,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 337.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 315,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 382.5,
        width: 28,
        height: 21.5,
        text: '2',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 360,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 337.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 315,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'paytable-symbols-value',
        type: 'Text',
        x: 0,
        y: 75,
        width: 960,
        height: 50,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 24,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: '1-2',
        type: 'PayoutText',
        x: 400,
        y: 222.5,
        width: 80,
        height: 21.5,
        text: '€2.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '1-3',
        type: 'PayoutText',
        x: 400,
        y: 200,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '1-4',
        type: 'PayoutText',
        x: 400,
        y: 177.5,
        width: 80,
        height: 21.5,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '1-5',
        type: 'PayoutText',
        x: 400,
        y: 155,
        width: 80,
        height: 21.5,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '2-5',
        type: 'PayoutText',
        x: 640,
        y: 155,
        width: 80,
        height: 21.5,
        text: 'JACKPOT',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '2-4',
        type: 'PayoutText',
        x: 640,
        y: 177.5,
        width: 80,
        height: 21.5,
        text: '€2500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '2-3',
        type: 'PayoutText',
        x: 640,
        y: 200,
        width: 80,
        height: 21.5,
        text: '€200.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '2-2',
        type: 'PayoutText',
        x: 640,
        y: 222.5,
        width: 80,
        height: 21.5,
        text: '€10.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'A-5',
        type: 'PayoutText',
        x: 400,
        y: 315,
        width: 80,
        height: 21.5,
        text: '€2000.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'A-4',
        type: 'PayoutText',
        x: 400,
        y: 337.5,
        width: 80,
        height: 21.5,
        text: '€125.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'A-3',
        type: 'PayoutText',
        x: 400,
        y: 360,
        width: 80,
        height: 21.5,
        text: '€25.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'A-2',
        type: 'PayoutText',
        x: 400,
        y: 382.5,
        width: 80,
        height: 21.5,
        text: '€2.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'B-2',
        type: 'PayoutText',
        x: 640,
        y: 382.5,
        width: 80,
        height: 21.5,
        text: '€2.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'B-3',
        type: 'PayoutText',
        x: 640,
        y: 360,
        width: 80,
        height: 21.5,
        text: '€25.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'B-4',
        type: 'PayoutText',
        x: 640,
        y: 337.5,
        width: 80,
        height: 21.5,
        text: '€125.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'B-5',
        type: 'PayoutText',
        x: 640,
        y: 315,
        width: 80,
        height: 21.5,
        text: '€1000.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '1',
        type: 'Image',
        x: 265,
        y: 120,
        width: 105.5,
        height: 133,
        scale: 0.5,
        images: ['images/main/items/static/1.png'],
      },
      {
        name: '2',
        type: 'Image',
        x: 505,
        y: 134.32,
        width: 105.5,
        height: 133,
        scale: 0.5,
        images: ['images/main/items/static/2.png'],
      },
      {
        name: 'A',
        type: 'Image',
        x: 265,
        y: 295,
        width: 105.5,
        height: 133,
        scale: 0.5,
        images: ['images/main/items/static/A.png'],
      },
      {
        name: 'B',
        type: 'Image',
        x: 505,
        y: 295,
        width: 105.5,
        height: 133,
        scale: 0.5,
        images: ['images/main/items/static/B.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 268,
        y: 66,
        width: 426,
        height: 394,
        alpha: 0.01,
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 155,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 177.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 200,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 222.5,
        width: 28,
        height: 21.5,
        text: '2',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 222.5,
        width: 28,
        height: 21.5,
        text: '2',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 200,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 177.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 155,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 325,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 347.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 370,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 370,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 347.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 325,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'C-5',
        type: 'PayoutText',
        x: 400,
        y: 155,
        width: 80,
        height: 21.5,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'C-4',
        type: 'PayoutText',
        x: 400,
        y: 177.5,
        width: 80,
        height: 21.5,
        text: '€75.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'C-3',
        type: 'PayoutText',
        x: 400,
        y: 200,
        width: 80,
        height: 21.5,
        text: '€10.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'C-2',
        type: 'PayoutText',
        x: 400,
        y: 222.5,
        width: 80,
        height: 21.5,
        text: '€2.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'D-2',
        type: 'PayoutText',
        x: 640,
        y: 222.5,
        width: 80,
        height: 21.5,
        text: '€2.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'D-3',
        type: 'PayoutText',
        x: 640,
        y: 200,
        width: 80,
        height: 21.5,
        text: '€10.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'D-4',
        type: 'PayoutText',
        x: 640,
        y: 177.5,
        width: 80,
        height: 21.5,
        text: '€75.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'D-5',
        type: 'PayoutText',
        x: 640,
        y: 155,
        width: 80,
        height: 21.5,
        text: '€300.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'E-5',
        type: 'PayoutText',
        x: 400,
        y: 325,
        width: 80,
        height: 21.5,
        text: '€150.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'E-4',
        type: 'PayoutText',
        x: 400,
        y: 347.5,
        width: 80,
        height: 21.5,
        text: '€30.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'E-3',
        type: 'PayoutText',
        x: 400,
        y: 370,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'F-3',
        type: 'PayoutText',
        x: 640,
        y: 370,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'F-4',
        type: 'PayoutText',
        x: 640,
        y: 347.5,
        width: 80,
        height: 21.5,
        text: '€30.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'F-5',
        type: 'PayoutText',
        x: 640,
        y: 325,
        width: 80,
        height: 21.5,
        text: '€150.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'paytable-symbols-value',
        type: 'Text',
        x: 0,
        y: 75,
        width: 960,
        height: 50,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 24,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'C',
        type: 'Image',
        x: 265,
        y: 135,
        width: 105.5,
        height: 133,
        scale: 0.5,
        images: ['images/main/items/static/C.png'],
      },
      {
        name: 'D',
        type: 'Image',
        x: 505,
        y: 135,
        width: 105.5,
        height: 133,
        scale: 0.5,
        images: ['images/main/items/static/D.png'],
      },
      {
        name: 'E',
        type: 'Image',
        x: 265,
        y: 295,
        width: 105.5,
        height: 133,
        scale: 0.5,
        images: ['images/main/items/static/E.png'],
      },
      {
        name: 'F',
        type: 'Image',
        x: 505,
        y: 295,
        width: 105.5,
        height: 133,
        scale: 0.5,
        images: ['images/main/items/static/F.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 268,
        y: 66,
        width: 426,
        height: 394,
        alpha: 0.01,
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 165,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 187.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 210,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 210,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 187.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 165,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 325,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 347.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 370,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 370,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 347.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 325,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'G-5',
        type: 'PayoutText',
        x: 400,
        y: 165,
        width: 80,
        height: 21.5,
        text: '€125.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'G-4',
        type: 'PayoutText',
        x: 400,
        y: 187.5,
        width: 80,
        height: 21.5,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'G-3',
        type: 'PayoutText',
        x: 400,
        y: 210,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'H-3',
        type: 'PayoutText',
        x: 640,
        y: 210,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'H-4',
        type: 'PayoutText',
        x: 640,
        y: 187.5,
        width: 80,
        height: 21.5,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'H-5',
        type: 'PayoutText',
        x: 640,
        y: 165,
        width: 80,
        height: 21.5,
        text: '€125.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'I-5',
        type: 'PayoutText',
        x: 400,
        y: 325,
        width: 80,
        height: 21.5,
        text: '€75.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'I-4',
        type: 'PayoutText',
        x: 400,
        y: 347.5,
        width: 80,
        height: 21.5,
        text: '€15.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'I-3',
        type: 'PayoutText',
        x: 400,
        y: 370,
        width: 80,
        height: 21.5,
        text: '€3.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'J-3',
        type: 'PayoutText',
        x: 640,
        y: 370,
        width: 80,
        height: 21.5,
        text: '€3.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'J-4',
        type: 'PayoutText',
        x: 640,
        y: 347.5,
        width: 80,
        height: 21.5,
        text: '€15.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'J-5',
        type: 'PayoutText',
        x: 640,
        y: 325,
        width: 80,
        height: 21.5,
        text: '€75.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'paytable-symbols-value',
        type: 'Text',
        x: 0,
        y: 75,
        width: 960,
        height: 50,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 24,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'G',
        type: 'Image',
        x: 265,
        y: 135,
        width: 105.5,
        height: 133,
        scale: 0.5,
        images: ['images/main/items/static/G.png'],
      },
      {
        name: 'H',
        type: 'Image',
        x: 505,
        y: 135,
        width: 105.5,
        height: 133,
        scale: 0.5,
        images: ['images/main/items/static/H.png'],
      },
      {
        name: 'I',
        type: 'Image',
        x: 265,
        y: 292.5,
        width: 105.5,
        height: 133,
        scale: 0.5,
        images: ['images/main/items/static/I.png'],
      },
      {
        name: 'J',
        type: 'Image',
        x: 505,
        y: 292.5,
        width: 105.5,
        height: 133,
        scale: 0.5,
        images: ['images/main/items/static/J.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 268,
        y: 66,
        width: 426,
        height: 394,
        alpha: 0.01,
      },
      {
        name: 'paytable-lines',
        type: 'Text',
        x: 0,
        y: 75,
        width: 960,
        height: 50,
        text: 'linesHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 24,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'winline1',
        type: 'Image',
        x: 240,
        y: 150,
        width: 79,
        height: 46.5,
        scale: 0.28062963598164903,
        images: ['../halloween/images/main/winlines/winline1.png'],
      },
      {
        name: 'winline2',
        type: 'Image',
        x: 340,
        y: 150,
        width: 79,
        height: 46.5,
        scale: 0.28062963598164903,
        images: ['../halloween/images/main/winlines/winline2.png'],
      },
      {
        name: 'winline3',
        type: 'Image',
        x: 440,
        y: 150,
        width: 79,
        height: 46.5,
        scale: 0.28062963598164903,
        images: ['../halloween/images/main/winlines/winline3.png'],
      },
      {
        name: 'winline4',
        type: 'Image',
        x: 540,
        y: 150,
        width: 79,
        height: 46.5,
        scale: 0.27979095190402115,
        images: ['../halloween/images/main/winlines/winline4.png'],
      },
      {
        name: 'winline5',
        type: 'Image',
        x: 640,
        y: 150,
        width: 79,
        height: 46.5,
        scale: 0.27979095190402115,
        images: ['../halloween/images/main/winlines/winline5.png'],
      },
      {
        name: 'winline6',
        type: 'Image',
        x: 240,
        y: 225,
        width: 79,
        height: 46.5,
        scale: 0.27979095190402115,
        images: ['../halloween/images/main/winlines/winline6.png'],
      },
      {
        name: 'winline7',
        type: 'Image',
        x: 340,
        y: 225,
        width: 79,
        height: 46.5,
        scale: 0.27979095190402115,
        images: ['../halloween/images/main/winlines/winline7.png'],
      },
      {
        name: 'winline8',
        type: 'Image',
        x: 440,
        y: 225,
        width: 79,
        height: 46.5,
        scale: 0.27979095190402115,
        images: ['../halloween/images/main/winlines/winline8.png'],
      },
      {
        name: 'winline9',
        type: 'Image',
        x: 540,
        y: 225,
        width: 79,
        height: 46.5,
        scale: 0.27979095190402115,
        images: ['../halloween/images/main/winlines/winline9.png'],
      },
      {
        name: 'winline10',
        type: 'Image',
        x: 640,
        y: 225,
        width: 79,
        height: 46.5,
        scale: 0.27979095190402115,
        images: ['../halloween/images/main/winlines/winline10.png'],
      },
      {
        name: 'PaytableEntity-lines-describe-text',
        type: 'Text',
        x: 212.55,
        y: 310.87,
        width: 534.18,
        height: 104.665,
        text: 'payPaytable',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 534.18,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
      },
    },
  },
  {
    name: 'GameRulesEntity',
    objects: [
      {
        name: 'game-rules',
        type: 'Text',
        x: 210,
        y: 44.5,
        width: 540,
        height: 31,
        text: 'rulesHeader',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 540,
        },
      },
      {
        name: 'scroll',
        type: 'Graphics',
        x: 0,
        y: 0,
        width: 960,
        height: 3011.995,
        alpha: 0,
      },
      {
        name: 'GameRulesEntity-button-functions-text',
        type: 'Text',
        x: 219.22,
        y: 2095.17,
        width: 524,
        height: 31.335,
        text: 'buttonFunctions',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-spin-describe-text',
        type: 'Text',
        x: 267.11,
        y: 2320.23,
        width: 134.335,
        height: 62.335,
        text: 'spinDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 134.335,
        },
      },
      {
        name: 'GameRulesEntity-spin-text',
        type: 'Text',
        x: 290.11,
        y: 2269.23,
        width: 86.335,
        height: 29.835,
        text: 'spin',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 86.335,
        },
      },
      {
        name: 'GameRulesEntity-bet-header-text',
        type: 'Text',
        x: 605.59,
        y: 2269.86,
        width: 86.335,
        height: 29.835,
        text: 'betHeaderRules',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 86.335,
        },
      },
      {
        name: 'GameRulesEntity-bet-header-describe-text',
        type: 'Text',
        x: 582.26,
        y: 2317.7,
        width: 134.335,
        height: 72.165,
        text: 'betHeaderDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 134.335,
        },
      },
      {
        name: 'GameRulesEntity-menu-text',
        type: 'Text',
        x: 302.37,
        y: 2401.25,
        width: 400,
        height: 29.835,
        text: 'menu',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-home-text',
        type: 'Text',
        x: 302.37,
        y: 2459.25,
        width: 400,
        height: 29.835,
        text: 'home',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-cashier-text',
        type: 'Text',
        x: 302.37,
        y: 2514,
        width: 400,
        height: 29.835,
        text: 'cashier',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-game-rules-text',
        type: 'Text',
        x: 302.37,
        y: 2570,
        width: 400,
        height: 29.835,
        text: 'gameRules',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-paytable-text',
        type: 'Text',
        x: 303.37,
        y: 2626.2,
        width: 400,
        height: 29.835,
        text: 'paytable',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-additional-text',
        type: 'Text',
        x: 217.95,
        y: 2806.2,
        width: 524,
        height: 31.335,
        text: 'additional',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-additional-describe-text',
        type: 'Text',
        x: 217.95,
        y: 2848.2,
        width: 524,
        height: 22.585,
        text: 'additionalDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-generated-text',
        type: 'Text',
        x: 217.95,
        y: 2902.2,
        width: 524,
        height: 31.335,
        text: 'generated',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-generated-describe-text',
        type: 'Text',
        x: 217.95,
        y: 2939.2,
        width: 524,
        height: 29.585,
        text: 'generatedDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-game-settings-text',
        type: 'Text',
        x: 302.37,
        y: 2685.2,
        width: 400,
        height: 29.835,
        text: 'gameSettings',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-autoplay-text',
        type: 'Text',
        x: 420.39,
        y: 2269.27,
        width: 131.335,
        height: 29.835,
        text: 'startStopBtn',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 131.335,
        },
      },
      {
        name: 'GameRulesEntity-autoplay-describe-text',
        type: 'Text',
        x: 419.72,
        y: 2320.27,
        width: 129.665,
        height: 69.335,
        text: 'startStopBtnDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 129.665,
        },
      },
      {
        name: 'GameRulesEntity-about-game-text',
        type: 'Text',
        x: 217.42,
        y: 81.86,
        width: 524,
        height: 40,
        text: 'about',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-about-describe-text',
        type: 'Text',
        x: 217.42,
        y: 128.2,
        width: 524,
        height: 40,
        text: 'aboutDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-return-player-text',
        type: 'Text',
        x: 217.42,
        y: 192.09,
        width: 524,
        height: 40,
        text: 'return',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-return-player-describe-text',
        type: 'RtpText',
        x: 217.42,
        y: 227.82,
        width: 524,
        height: 40,
        text: 'returnDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-how-to-play-text',
        type: 'Text',
        x: 217.42,
        y: 513.59,
        width: 524,
        height: 40,
        text: 'howPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-how-to-play-describe-text',
        type: 'Text',
        x: 217.42,
        y: 547.09,
        width: 524,
        height: 40,
        text: 'howPlayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-hot-features-text',
        type: 'Text',
        x: 217.42,
        y: 543.2,
        width: 524,
        height: 40,
        context: { jackpot: true },
        text: 'hotFeatures',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-jackpot-text',
        type: 'Text',
        x: 217.42,
        y: 584.2,
        width: 524,
        height: 40,
        context: { jackpot: true },
        text: 'jackpot',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-jackpot-describe-text',
        type: 'Text',
        x: 217.42,
        y: 604.03,
        width: 524,
        height: 40,
        context: { jackpot: true },
        text: 'jackpotDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespins-text',
        type: 'Text',
        x: 217.42,
        y: 636.11,
        width: 524,
        height: 40,
        text: 'freespins',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-free-spins-describe-text',
        type: 'Text',
        x: 217.42,
        y: 690.7,
        width: 524,
        height: 22,
        context: { jackpot: true },
        text: 'excludeJackpot',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-scatter-text',
        type: 'Text',
        x: 217.42,
        y: 720.6,
        width: 524,
        height: 40,
        text: 'scatter',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-scatter-describe-text',
        type: 'Text',
        x: 217.42,
        y: 738.68,
        width: 524,
        height: 40,
        text: 'scatterDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-wild-text',
        type: 'Text',
        x: 217.42,
        y: 837,
        width: 524,
        height: 23.335,
        text: 'wild',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-wild-describe-text',
        type: 'Text',
        x: 217.42,
        y: 854.03,
        width: 524,
        height: 47.335,
        text: 'wildDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-hot-features-text',
        type: 'Text',
        x: 217.42,
        y: 601.55,
        width: 524,
        height: 40,
        context: { jackpot: false },
        text: 'hotFeatures',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespins-describe-text',
        type: 'Text',
        x: 217.42,
        y: 666.97,
        width: 524,
        height: 23.335,
        text: 'freespinsDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays-text',
        type: 'Text',
        x: 217.42,
        y: 267.33,
        width: 524,
        height: 40,
        text: 'pays',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin-title-text',
        type: 'Text',
        x: 217.42,
        y: 952,
        width: 524,
        height: 40,
        text: 'freespinsGameRules',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin1-describe-text',
        type: 'Text',
        x: 217.42,
        y: 980.37,
        width: 524,
        height: 40,
        text: 'freespinsGameRulesD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin2-describe-text',
        type: 'Text',
        x: 217.42,
        y: 1035.87,
        width: 524,
        height: 40,
        text: 'freespinsGameRulesE',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin3-describe-text',
        type: 'Text',
        x: 217.42,
        y: 1084.37,
        width: 524,
        height: 40,
        text: 'freespinsGameRulesS',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin4-describe-text',
        type: 'Text',
        x: 217.42,
        y: 1141.37,
        width: 524,
        height: 40,
        text: 'freespinsGameRulesC',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin5-describe-text',
        type: 'Text',
        x: 217.42,
        y: 1176.87,
        width: 524,
        height: 40,
        text: 'freespinsGameRulesR',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin6-describe-text',
        type: 'Text',
        x: 217.42,
        y: 1232.37,
        width: 524,
        height: 40,
        text: 'freespinsGameRulesI',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-bet-text',
        type: 'Text',
        x: 217.42,
        y: 1289.45,
        width: 524,
        height: 40,
        text: 'betGame',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-bet-describe-text',
        type: 'Text',
        x: 217.42,
        y: 1331.87,
        width: 524,
        height: 40,
        text: 'betGameDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-startstop-text',
        type: 'Text',
        x: 217.42,
        y: 1396.52,
        width: 524,
        height: 40,
        text: 'startStop',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-desktopv-text',
        type: 'Text',
        x: 217.42,
        y: 1584.18,
        width: 524,
        height: 40,
        text: 'desktopVersion',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-keyboard-text',
        type: 'Text',
        x: 216.75,
        y: 1921.99,
        width: 524,
        height: 40,
        text: 'keyboard',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-keyboard-describe-text',
        type: 'Text',
        x: 216.75,
        y: 1977.91,
        width: 524,
        height: 40,
        text: 'keyboardDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-keyboard3-describe-text',
        type: 'Text',
        x: 215.9,
        y: 2028.27,
        width: 524,
        height: 40,
        text: 'keyboardDescribeE',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays4-describe-text',
        type: 'Text',
        x: 218,
        y: 461.67,
        width: 524,
        height: 53.665,
        text: 'paysDescribeE',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays3-describe-text',
        type: 'Text',
        x: 218,
        y: 430.67,
        width: 524,
        height: 53.665,
        text: 'paysDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays2-describe-text',
        type: 'Text',
        x: 217.42,
        y: 349.5,
        width: 524,
        height: 40,
        text: 'paysDescribeP',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays-describe-text',
        type: 'Text',
        x: 217.42,
        y: 305.5,
        width: 524,
        height: 40,
        text: 'paysDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-startstop-describe-text',
        type: 'Text',
        x: 217.42,
        y: 1449.94,
        width: 524,
        height: 40,
        text: 'startStopDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-startstop2-describe-text',
        type: 'Text',
        x: 217.42,
        y: 1509.44,
        width: 524,
        height: 40,
        text: 'startStopDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-desktopv-describe-text',
        type: 'Text',
        x: 217.42,
        y: 1635.03,
        width: 524,
        height: 40,
        text: 'desktopVersionDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-desktopv2-describe-text',
        type: 'Text',
        x: 217.42,
        y: 1690.03,
        width: 524,
        height: 40,
        text: 'desktopVersionDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-mobile-text',
        type: 'Text',
        x: 217,
        y: 1789.13,
        width: 524,
        height: 31.335,
        text: 'leftHandMode',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-mobile-describe-text',
        type: 'Text',
        x: 217,
        y: 1830.97,
        width: 524,
        height: 55,
        text: 'leftHandModeDescription',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 297.25,
        y: 2168.23,
        width: 70,
        height: 70,
        scale: 0.2692307692307692,
        images: ['../halloween/images/main/buttons/spin-0.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 453,
        y: 2168.62,
        width: 70,
        height: 70,
        scale: 0.2692307692307692,
        images: ['../halloween/images/main/buttons/spin-1.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 614,
        y: 2168.62,
        width: 70,
        height: 70,
        scale: 0.5,
        images: ['../halloween/images/main/buttons/bet-button-0.png'],
      },
      {
        name: 'HISTORY - tap to view your latest game bets and payout',
        type: 'Text',
        x: 302,
        y: 2741.5,
        width: 400,
        height: 29.835,
        text: 'history',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
      },
    },
  },
  {
    name: 'BetEntity',
    objects: [
      {
        name: 'bet',
        type: 'Text',
        width: 471.335,
        height: 35.92,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 471.335,
        },
        orientation: {
          land: {
            x: 247.665,
            y: 44.755,
          },
          port: {
            x: 40,
            y: 162.5,
          },
        },
      },
      {
        name: 'ui-bet',
        type: 'RadioButton',
        width: 55,
        height: 55,
        deselect: true,
        direction: true,
        hitzone: 2,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 658.5,
            y: 30,
          },
          port: {
            x: 451.59,
            y: 165.09,
          },
        },
      },
      {
        name: 'field',
        type: 'BetField',
        width: 474.265,
        height: 356.905,
        numberOfButtons: 24,
        textPosX: 110,
        textPosY: 50,
        texture: 'button-0',
        orientation: {
          land: {
            x: 245.205,
            y: 105.34,
          },
          port: {
            x: 38.005,
            y: 246.915,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'SettingsEntity',
    objects: [
      {
        name: 'settings',
        type: 'Text',
        width: 400,
        height: 28.335,
        text: 'settings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
        orientation: {
          land: {
            x: 280.325,
            y: 62.665,
          },
          port: {
            x: 64,
            y: 96,
          },
        },
      },
      {
        name: 'space',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        runtime: { platform: 'desktop' },
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 224,
          },
          port: {
            x: 401.66,
            y: 363.34,
          },
        },
      },
      {
        name: 'space',
        type: 'Text',
        width: 303.485,
        height: 27.5,
        runtime: { platform: 'desktop' },
        text: 'space',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 303.485,
        },
        orientation: {
          port: {
            x: 64.665,
            y: 367.915,
          },
          land: {
            x: 280,
            y: 224,
          },
        },
      },
      {
        name: 'sound',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 176,
          },
          port: {
            x: 403,
            y: 296,
          },
        },
      },
      {
        name: 'sound',
        type: 'Text',
        width: 303.485,
        height: 27.5,
        text: 'sound',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 303.485,
        },
        orientation: {
          port: {
            x: 64,
            y: 298.085,
          },
          land: {
            x: 280,
            y: 176,
          },
        },
      },
      {
        name: 'left',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        runtime: { platform: 'mobile,tablet' },
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 224,
          },
          port: {
            x: 401,
            y: 363,
          },
        },
      },
      {
        name: 'left',
        type: 'Text',
        width: 303.485,
        height: 27.5,
        runtime: { platform: 'mobile,tablet' },
        text: 'leftHand',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 303.485,
        },
        orientation: {
          port: {
            x: 65,
            y: 371,
          },
          land: {
            x: 280,
            y: 224,
          },
        },
      },
      {
        name: 'turbo',
        type: 'Text',
        width: 329,
        height: 27.5,
        text: 'turboModeSettings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 329,
        },
        orientation: {
          land: {
            x: 280,
            y: 128,
          },
          port: {
            x: 61,
            y: 229,
          },
        },
      },
      {
        name: 'turbo',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 126,
          },
          port: {
            x: 400,
            y: 232,
          },
        },
      },
      {
        name: 'fps',
        type: 'Text',
        width: 329,
        height: 27.5,
        text: 'fps',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 329,
        },
        orientation: {
          land: {
            x: 280,
            y: 272,
          },
          port: {
            x: 65,
            y: 444,
          },
        },
      },
      {
        name: 'cheat',
        type: 'Text',
        width: 329,
        height: 27.5,
        context: { debug: true },
        text: 'cheat',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 329,
        },
        orientation: {
          land: {
            x: 280,
            y: 320,
          },
          port: {
            x: 65,
            y: 517,
          },
        },
      },
      {
        name: 'cheat',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        context: { debug: true },
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 314.5,
          },
          port: {
            x: 401.5,
            y: 517,
          },
        },
      },
      {
        name: 'fps',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 269,
          },
          port: {
            x: 401.5,
            y: 444,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'MenuEntity',
    objects: [
      {
        name: 'menuhome',
        type: 'ImageButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: ['images/icons/menu-home.png'],
        orientation: {
          land: {
            x: 55,
            y: 70,
          },
          port: {
            x: 107.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menu-gamerules',
        type: 'RadioButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/icons/menu-info-0.png',
          'images/icons/menu-info-1.png',
        ],
        orientation: {
          land: {
            x: 55,
            y: 180,
          },
          port: {
            x: 237.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menu-paytable',
        type: 'RadioButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/icons/menu-paytable-0.png',
          'images/icons/menu-paytable-1.png',
        ],
        orientation: {
          land: {
            x: 55,
            y: 235,
          },
          port: {
            x: 302.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menucashier',
        type: 'ImageButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: ['images/icons/menu-cashier-1.png'],
        orientation: {
          land: {
            x: 55,
            y: 125,
          },
          port: {
            x: 172.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menu-settings',
        type: 'RadioButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/icons/menu-settings-0.png',
          'images/icons/menu-settings-1.png',
        ],
        orientation: {
          land: {
            x: 55,
            y: 290,
          },
          port: {
            x: 367.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menuhistory',
        type: 'ImageButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 3,
        scale: 0.5,
        images: ['images/icons/menu-history-1.png'],
        orientation: {
          land: {
            x: 55,
            y: 345,
          },
          port: {
            x: 432.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'ui-menu',
        type: 'RadioButton',
        width: 50,
        height: 50,
        deselect: true,
        direction: true,
        hitzone: 2,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 50,
            y: 397,
          },
          port: {
            x: 26.5,
            y: 775,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIRegularEntity',
    objects: [
      {
        name: 'spin',
        type: 'SpinButton',
        width: 128.335,
        height: 128.335,
        direction: true,
        scale: 0.49359615384615385,
        images: [
          'images/icons/spin-0.png',
          'images/icons/spin-1.png',
        ],
        orientation: {
          land: {
            x: 842.17,
            y: 203,
          },
          port: {
            x: 208.23,
            y: 716,
            v: 1,
          },
        },
      },
      {
        name: 'ui-bet',
        type: 'RadioButton',
        width: 67.835,
        height: 67.835,
        deselect: true,
        direction: true,
        hitzone: 3,
        scale: 0.48453571428571424,
        images: [
          'images/icons/bet-button-0.png',
          'images/icons/bet-button-1.png',
        ],
        orientation: {
          port: {
            x: 115.5,
            y: 763.5,
            v: 1,
          },
          land: {
            x: 873.34,
            y: 349,
          },
        },
      },
      {
        name: 'ui-menu',
        type: 'RadioButton',
        width: 50,
        height: 50,
        deselect: true,
        direction: true,
        hitzone: 6,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 50,
            y: 397,
          },
          port: {
            x: 26.5,
            y: 775.5,
            v: 1,
          },
        },
      },
      {
        name: 'autostop',
        type: 'ImageButton',
        width: 70,
        height: 70,
        direction: true,
        scale: 0.4430379746835443,
        images: ['images/icons/stop-autoplay.png'],
        orientation: {
          port: {
            x: 454.5,
            y: 763,
            v: 1,
          },
          land: {
            x: 867.83,
            y: 27,
          },
        },
      },
      {
        name: 'ui-automenu',
        type: 'RadioButton',
        width: 70,
        height: 70,
        deselect: true,
        direction: true,
        scale: 0.5,
        images: [
          'images/icons/auto-menu-0.png',
          'images/icons/auto-menu-1.png',
        ],
        orientation: {
          land: {
            x: 872.67,
            y: 32,
          },
          port: {
            x: 454.5,
            y: 763,
            v: 1,
          },
        },
      },
      {
        name: 'autospin-text',
        type: 'AutoCountText',
        width: 50,
        height: 50,
        direction: true,
        text: '10',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 50,
        },
        orientation: {
          land: {
            x: 881.165,
            y: 241,
          },
          port: {
            x: 246.16,
            y: 754,
            v: 1,
          },
        },
      },
      {
        name: 'you-win',
        type: 'WinText',
        width: 206,
        height: 17.5,
        text: '$5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 206,
        },
        orientation: {
          port: {
            x: 163.5,
            y: 892.5,
            v: 1,
          },
          land: {
            x: 385,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'free-bet-count',
        type: 'FreeBetLeft',
        width: 100,
        height: 17.5,
        text: '$5,00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 702.5,
            y: 480.5,
            v: 1,
          },
          port: {
            x: 338.595,
            y: 892.5,
            v: 1,
          },
        },
      },
      {
        name: 'you-win',
        type: 'Text',
        width: 135,
        height: 17.5,
        text: 'win',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 135,
        },
        orientation: {
          port: {
            x: 198,
            y: 868.5,
            v: 1,
          },
          land: {
            x: 418.895,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'free-bet-text',
        type: 'FreeBetText',
        width: 135,
        height: 17.5,
        text: 'freeBetLeft',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 682.115,
            y: 463,
            v: 1,
          },
          port: {
            x: 317.45,
            y: 869.23,
            v: 1,
          },
        },
      },
      {
        name: 'sound-bg',
        type: 'Image',
        width: 70,
        height: 70,
        direction: true,
        scale: 0.5185185185185185,
        images: ['images/underlay/circle-small.png'],
        orientation: {
          land: {
            x: 872,
            y: 118,
          },
          port: {
            x: 353,
            y: 763,
            v: 1,
          },
        },
      },
      {
        name: 'sound',
        type: 'ToggleButton',
        width: 52.71,
        height: 45.18,
        direction: true,
        scale: 0.753,
        images: [
          'images/icons/sound-0.png',
          'images/icons/sound-1.png',
        ],
        orientation: {
          land: {
            x: 880.56,
            y: 129.82,
          },
          port: {
            x: 361.13,
            y: 775,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIFreespinsEntity',
    objects: [
      {
        name: 'frame-spin',
        type: 'Image',
        width: 130,
        height: 130,
        direction: true,
        scale: 0.5,
        images: ['images/icons/spin-0.png'],
        orientation: {
          land: {
            x: 842.17,
            y: 203,
          },
          port: {
            x: 206.67,
            y: 713.5,
            v: 1,
          },
        },
      },
      {
        name: 'freespinsCount',
        type: 'FreespinsCountText',
        width: 124,
        height: 124,
        direction: true,
        text: '15',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 124,
        },
        orientation: {
          land: {
            x: 844.62,
            y: 205.42,
          },
          port: {
            x: 210.335,
            y: 717.165,
            v: 1,
          },
        },
      },
      {
        name: 'total-name-p',
        type: 'Text',
        width: 153.335,
        height: 17.5,
        text: 'youWin',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 153.335,
        },
        orientation: {
          port: {
            x: 264,
            y: 868.5,
            v: 1,
          },
        },
      },
      {
        name: 'total-name',
        type: 'Text',
        width: 150,
        height: 17.5,
        text: 'youWin',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 150,
        },
        orientation: {
          land: {
            x: 675.21,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'total-value-p',
        type: 'FreespinsTotalWinText',
        width: 241,
        height: 17.5,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 241,
        },
        orientation: {
          port: {
            x: 223,
            y: 892.5,
            v: 1,
          },
        },
      },
      {
        name: 'total-value',
        type: 'FreespinsTotalWinText',
        width: 206,
        height: 17.5,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 206,
        },
        orientation: {
          land: {
            x: 645.64,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'you-win-text-fs',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'youWinName',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          land: {
            x: 192,
            y: 463.565,
            v: 1,
          },
          port: {
            x: 152,
            y: 868.5,
            v: 1,
          },
        },
      },
      {
        name: 'you-win-fs',
        type: 'WinText',
        width: 217.67,
        height: 17.5,
        text: '$5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 217.67,
        },
        orientation: {
          port: {
            x: 97.33,
            y: 892.5,
            v: 1,
          },
          land: {
            x: 134.565,
            y: 479.935,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIGeneralEntity',
    objects: [
      {
        name: 'bet-name',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'right',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          land: {
            x: 843.5,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'balance-name',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'balance',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'left',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          port: {
            x: 24,
            y: 868.5,
            v: 1,
          },
          land: {
            x: 19.75,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'bet-value',
        type: 'BetText',
        width: 175.76,
        height: 17.5,
        text: '$ 2',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 175.76,
        },
        orientation: {
          land: {
            x: 767.075,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'balance-value',
        type: 'BalanceText',
        width: 214.325,
        height: 17.5,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 214.325,
        },
        orientation: {
          port: {
            x: 24,
            y: 892.5,
            v: 1,
          },
          land: {
            x: 19.835,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'bet-name-p',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'right',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          port: {
            x: 424,
            y: 868.5,
            v: 1,
          },
        },
      },
      {
        name: 'bet-value-p',
        type: 'BetText',
        width: 175,
        height: 17.5,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 175,
        },
        orientation: {
          port: {
            x: 349,
            y: 892.5,
            v: 1,
          },
        },
      },
      {
        name: 'timer-clock',
        type: 'TimerText',
        width: 50,
        height: 17.5,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 50,
        },
        orientation: {
          land: {
            x: 20,
            y: 510,
            v: 1,
          },
          port: {
            x: 24,
            y: 939,
            v: 1,
          },
        },
      },
      {
        name: 'timer-name',
        type: 'Text',
        width: 74.55,
        height: 17.5,
        text: 'timeElapsed',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 10,
          align: 'left',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 74.55,
        },
        orientation: {
          land: {
            x: 75,
            y: 510,
            v: 1,
          },
          port: {
            x: 75.175,
            y: 939,
            v: 1,
          },
        },
      },
      {
        name: 'net-balance',
        type: 'NetPosition',
        width: 81.945,
        height: 17.5,
        text: '',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 81.945,
        },
        orientation: {
          land: {
            x: 860.5,
            y: 510,
            v: 1,
          },
          port: {
            x: 440,
            y: 939,
            v: 1,
          },
        },
      },
      {
        name: 'net-name',
        type: 'Text',
        width: 75.175,
        height: 17.5,
        text: 'netPosition',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 10,
          align: 'right',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 75.175,
        },
        orientation: {
          land: {
            x: 784,
            y: 510,
            v: 1,
          },
          port: {
            x: 363,
            y: 939,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreebetEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'bg',
        type: 'Image',
        width: 370,
        height: 255,
        scale: 0.5,
        images: ['images/underlay/free-bet-bg.png'],
        orientation: {
          land: {
            x: 295,
            y: 140.24,
          },
        },
      },
      {
        name: 'bg-p',
        type: 'Image',
        width: 370,
        height: 255,
        scale: 0.5,
        images: ['images/underlay/free-bet-bg.png'],
        orientation: {
          port: {
            x: 95,
            y: 315.36,
          },
        },
      },
      {
        name: 'FB-CLOSE',
        type: 'RadioButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 424.84,
            y: 321.17,
          },
          port: {
            x: 223.29,
            y: 493.22,
          },
        },
      },
      {
        name: 'text',
        type: 'Text',
        width: 112.415,
        height: 51.585,
        text: 'OK',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 112.415,
        },
        orientation: {
          land: {
            x: 424.665,
            y: 323,
          },
          port: {
            x: 223.79,
            y: 494.86,
          },
        },
      },
      {
        name: 'fb-end',
        type: 'FreeBetWinText',
        width: 370.835,
        height: 74.425,
        text: 'freeBetTotalWin',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32.5,
          align: 'center',
          valign: 'center',
          fill: '#f99531',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 370.835,
        },
        orientation: {
          land: {
            x: 293.915,
            y: 224.79,
          },
          port: {
            x: 94.94,
            y: 396.715,
          },
        },
      },
      {
        name: 'fb-end-popup',
        type: 'PopupText',
        width: 366.57,
        height: 79.14,
        text: 'freeBetEnd',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 366.57,
        },
        orientation: {
          land: {
            x: 297.38,
            y: 139.765,
          },
          port: {
            x: 95.285,
            y: 317.575,
          },
        },
      },
      {
        name: 'fb-add',
        type: 'FreeBetCountText',
        width: 370.835,
        height: 74.425,
        text: 'freeBetsCount',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32.5,
          align: 'center',
          valign: 'center',
          fill: '#f99531',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 370.835,
        },
        orientation: {
          land: {
            x: 293.915,
            y: 224.79,
          },
          port: {
            x: 94.94,
            y: 398.5,
          },
        },
      },
      {
        name: 'fb-add-popup',
        type: 'PopupText',
        width: 370.835,
        height: 74.425,
        text: 'congrats',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 370.835,
        },
        orientation: {
          land: {
            x: 294.835,
            y: 139.325,
          },
          port: {
            x: 95.93,
            y: 312.28,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'IntroScreenEntity',
    objects: [
      {
        name: 'ss-bg',
        type: 'Image',
        width: 1601,
        height: 1601,
        scale: 0.5,
        images: ['images/splash/ss_bg_bg.png'],
        orientation: {
          land: {
            x: -320,
            y: -525,
          },
        },
      },
      {
        name: 'ss-port',
        type: 'Image',
        width: 1601,
        height: 1601,
        scale: 0.5,
        images: ['images/splash/ss_bg_bg.png'],
        orientation: {
          port: {
            x: -525,
            y: -320,
          },
        },
      },
      {
        name: 'intro-l-sc',
        type: 'AnimationSpine',
        width: 3200,
        height: 3200,
        animation: 'land',
        oriented: false,
        spine: 'animations/spine/splash-sc/skeleton.json',
        orientation: {
          land: {
            x: -3200,
            y: -580,
            scale: 0.5,
          },
        },
      },
      {
        name: 'intro-sc-p',
        type: 'AnimationSpine',
        width: 3200,
        height: 3200,
        animation: 'port',
        oriented: false,
        spine: 'animations/spine/splash/skeleton.json',
        orientation: {
          port: {
            x: -3025,
            y: -320,
            scale: 0.5,
          },
        },
      },
      {
        name: 'ss_animation',
        type: 'AnimationSpine',
        width: 3200,
        height: 3200,
        animation: 'land',
        oriented: false,
        spine: 'animations/spine/splash/skeleton.json',
        orientation: {
          land: {
            x: -320,
            y: -580,
            scale: 0.5,
          },
        },
      },
      {
        name: 'ss_animation-p',
        type: 'AnimationSpine',
        width: 3200,
        height: 3200,
        animation: 'port',
        oriented: false,
        spine: 'animations/spine/splash/skeleton.json',
        orientation: {
          port: {
            x: -525,
            y: -320,
            scale: 0.5,
          },
        },
      },
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 1600,
        height: 1600,
        alpha: '0',
        orientation: {
          land: {
            x: -320,
            y: -525,
          },
          port: {
            x: -554.685,
            y: -175.5,
          },
        },
      },
      {
        name: 'close',
        type: 'GraphicsButton',
        width: 960,
        height: 960,
        alpha: 0,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'IntroScreenEntity-tap-to-play-text',
        type: 'Text',
        width: 960,
        height: 58.51,
        customStyle: 'symbolText',
        tween: 'introTween',
        text: 'tapPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
        orientation: {
          land: {
            x: 10,
            y: 430,
          },
        },
      },
      {
        name: 'IntroScreenEntity-tap-to-play-port-text',
        type: 'Text',
        width: 540,
        height: 62.84,
        customStyle: 'symbolText',
        tween: 'introTween',
        text: 'tapPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 540,
        },
        orientation: {
          port: {
            x: 20,
            y: 820,
          },
        },
      },
      {
        name: 'underloader',
        type: 'Image',
        width: 338,
        height: 12,
        scale: 0.5,
        images: ['../clover/images/splash/loader/loader-gray.png'],
        orientation: {
          port: {
            x: 109.5,
            y: 845.97,
          },
          land: {
            x: 311.07,
            y: 452.15,
          },
        },
      },
      {
        name: 'loaderline',
        type: 'Loader',
        width: 333,
        height: 8,
        scale: 0.5,
        images: ['../clover/images/splash/loader/loader-progress.png'],
        orientation: {
          land: {
            x: 313.71,
            y: 454,
          },
          port: {
            x: 112,
            y: 848,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'SoundPopupEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'sound-back',
        type: 'Image',
        width: 336,
        height: 173.42,
        scale: 0.5419364919354839,
        images: ['images/underlay/soundBack.png'],
        orientation: {
          land: {
            x: 309,
            y: 179.34,
          },
          port: {
            x: 108.5,
            y: 377,
          },
        },
      },
      {
        name: 'sound-1',
        type: 'ImageButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: ['images/icons/button-0.png'],
        orientation: {
          land: {
            x: 354,
            y: 249.5,
          },
          port: {
            x: 142,
            y: 448.5,
          },
        },
      },
      {
        name: 'sound-0',
        type: 'ImageButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: ['images/icons/button-0.png'],
        orientation: {
          land: {
            x: 493,
            y: 249.5,
          },
          port: {
            x: 304,
            y: 448,
          },
        },
      },
      {
        name: 'enable-sound',
        type: 'Text',
        width: 349.335,
        height: 38.165,
        text: 'soundQuestion',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 349.335,
        },
        orientation: {
          land: {
            x: 300,
            y: 199.5,
          },
          port: {
            x: 107.5,
            y: 391.335,
          },
        },
      },
      {
        name: 'sound-yes',
        type: 'Text',
        width: 54.5,
        height: 52.5,
        text: 'soundYes',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 54.5,
        },
        orientation: {
          land: {
            x: 400,
            y: 250,
          },
          port: {
            x: 177.665,
            y: 448,
          },
        },
      },
      {
        name: 'sound-no',
        type: 'Text',
        width: 54.5,
        height: 52.5,
        text: 'soundNo',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 54.5,
        },
        orientation: {
          land: {
            x: 535,
            y: 250,
          },
          port: {
            x: 344.665,
            y: 449,
          },
        },
      },
      {
        name: 'sound-yes-pic',
        type: 'Image',
        width: 24.025,
        height: 26.52,
        scale: 0.4058076923076923,
        images: ['images/icons/sound-1.png'],
        orientation: {
          land: {
            x: 367.09,
            y: 262.08,
          },
          port: {
            x: 152.17,
            y: 460.42,
          },
        },
      },
      {
        name: 'sound-no-pic',
        type: 'Image',
        width: 35,
        height: 30,
        scale: 0.5,
        images: ['images/icons/sound-0.png'],
        orientation: {
          land: {
            x: 505.17,
            y: 261,
          },
          port: {
            x: 316.5,
            y: 459.67,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'PopupEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'image',
        type: 'PopupButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 418.17,
            y: 324.5,
          },
          port: {
            x: 221.5,
            y: 470,
          },
        },
      },
      {
        name: 'text',
        type: 'PopupButton',
        width: 112.415,
        height: 51.585,
        text: 'OK',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 112.415,
        },
        orientation: {
          land: {
            x: 418,
            y: 326.335,
          },
          port: {
            x: 222.005,
            y: 471.645,
          },
        },
      },
      {
        name: 'body',
        type: 'PopupText',
        width: 475.5,
        height: 168.425,
        text: 'NO INTERNET CONNECTION.\nPLEASE CHECK YOUR CONNECTION\nAND RELOAD THE GAME TO CONTINUE',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 475.5,
        },
        orientation: {
          land: {
            x: 241.5,
            y: 101.325,
          },
          port: {
            x: 37.005,
            y: 280.135,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'FullscreenEntity',
    objects: [
      {
        name: 'fullscreen',
        type: 'GraphicsButton',
        width: 960,
        height: 960,
        alpha: 0.5,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'tapa',
        type: 'Image',
        width: 126,
        height: 212.5,
        runtime: {
          os: 'android',
          platform: 'mobile,tablet',
        },
        scale: 0.5,
        images: ['images/icons/fullscreen-1.png'],
        orientation: {
          land: {
            x: 423.67,
            y: 164,
          },
          port: {
            x: 213.5,
            y: 372.84,
          },
        },
      },
      {
        name: 'tap',
        type: 'AnimationSpine',
        width: 329,
        height: 471,
        runtime: {
          os: 'ios',
          platform: 'mobile,tablet',
        },
        spine: 'animations/spine/fullscreen/skeleton.json',
        orientation: {
          land: {
            x: 398,
            y: 147.5,
            scale: 0.5,
          },
          port: {
            x: 197,
            y: 357.5,
            scale: 0.5,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'LoadingEntity',
    objects: [
      {
        name: 'logoanim',
        type: 'LogoSpine',
        width: 960,
        height: 540,
        spine: 'brand/anim/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
          },
          port: {
            x: -410,
            y: 200,
          },
        },
      },
    ],
    properties: { parentGroup: 'INIT' },
  },
  {
    name: 'UIGeneralOverlayEntity',
    objects: [
      {
        name: 'intro-clock-l',
        type: 'ClockText',
        width: 54.765,
        height: 20.4,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 54.765,
        },
        orientation: {
          land: {
            x: 880.81,
            y: 4.53,
            v: -1,
          },
        },
      },
      {
        name: 'intro-clock-p',
        type: 'ClockText',
        width: 46.835,
        height: 15.835,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14.5,
          align: 'left',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 46.835,
        },
        orientation: {
          port: {
            x: 490.775,
            y: 3.42,
            h: 1,
            v: -1,
          },
        },
      },
      {
        name: 'game-name',
        type: 'Text',
        width: 233.115,
        height: 14.795,
        alpha: 0.5,
        force: false,
        text: 'gameName',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 10,
          align: 'left',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 6.765,
            y: 0,
            h: -1,
            v: -1,
          },
          port: {
            x: 11.9,
            y: 4.41,
            h: -1,
            v: -1,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
]
